import { AgGridReact } from 'ag-grid-react';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import BookAppointMent from '../../../modules/BookAppointMent';
import { AiOutlineCheck } from 'react-icons/ai';
import { BsBackspace } from 'react-icons/bs';
import { MdDoneAll, MdVerifiedUser } from 'react-icons/md';
import { useToasts } from 'react-toast-notifications';
import { Option } from 'antd/lib/mentions';

import CustomDangerButton from '../../ui-elements/Buttons/CustomDangerButton';
import CustomButtons from '../../ui-elements/Buttons/CustomButtons';
import AptHeader from '../../../components/Apt/AptHeader/AptHeader';
import { Tooltip } from '@mui/material';
import { useNavigate } from 'react-router';
import LdcApi from '../../../LdcApis';
import Skelton from '../../../components/Skelton/Skelton';
import { SiMinutemailer } from 'react-icons/si';
import { Button, Form, Modal, Row } from 'react-bootstrap';
import 'react-quill/dist/quill.snow.css';

import dayjs from 'dayjs';

// import SurgeryMailReviewTemplate from '../../components/MailTemplates/SurgeryMailReviewTemplate';
const userInfo = JSON.parse(localStorage.getItem('user_info'));

function ComplicationTracker() {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = 'Complications Tracker - LDC';
  });
  const { RangePicker } = DatePicker;
  const dateFormat = 'DD/MM/YYYY';
  const now = new Date();
  const mailRef = useRef();
  const [reviewData, setReviewData] = useState([]);
  const { addToast } = useToasts();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [allProvitionalApt, setAllProvitionalApt] = useState([]);
  const [showProvisison, setshowProvisison] = useState({
    open: false,
    aptData: null,
  });
  const [startDate, setStartDate] = useState(new Date());
  const users = JSON.parse(localStorage.getItem('user_info'));
  const users_ID = JSON.parse(localStorage.getItem('user'));
  const [isClickCompleted, setIsClickCompleted] = useState(false);
  const [loader, setLoader] = useState(false);
  const [sentMailOpenBool, setSentMailOpenBool] = useState(false);
  const [labLoader, setLabLoader] = useState(false);

  const [followUpTrackerData, setFollowUpTrackerData] = useState([]);
  const [loaderSpinForMailSent, setLoaderSpinForMailSent] = useState(false);
  const [selectRowId, setSelectRowId] = useState({});

  const defaultStartDate = dayjs().subtract(4, 'month').format('YYYY-MM-DD');
  const defaultEndDate = dayjs().format('YYYY-MM-DD');
  const [finalDateRange, setFinalDateRange] = useState({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  const [DateRangesss, setDateRangess] = useState({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });
  const [value, setValue] = useState(``);
  const viewOnly =
    userInfo?.roleName.replace(/\s/g, '').toUpperCase() === 'VIEWONLY';

  const [loading, setLoading] = useState(null);
  const finalDateRangeRef = useRef(finalDateRange);

  const [statusSelect, setStatusSelect] = useState('False');
  const statusSelectRef = useRef(statusSelect);
  const onChange = (dates, dateStrings) => {
    if (!dates || dates.length !== 2) return;

    const startDate = dates[0].format('YYYY-MM-DD');
    const endDate = dates[1].format('YYYY-MM-DD');

    setFinalDateRange({
      startDate,
      endDate,
    });

    setSelectedRange(dates); // Keep UI in sync
  };

  useEffect(() => {
    finalDateRangeRef.current = finalDateRange;
  }, [finalDateRange]);

  useEffect(() => {
    statusSelectRef.current = statusSelect;
  }, [statusSelect]);

  const defaultValue = [dayjs().subtract(4, 'month'), dayjs()];
  const [selectedRange, setSelectedRange] = useState(defaultValue);

  const fetchFollowUpData = (
    dateRange = finalDateRange,
    status = statusSelect
  ) => {
    setLabLoader(true);

    let formattedStartDate = dateRange.startDate.split('/').reverse().join('/');
    let formattedEndDate = dateRange.endDate.split('/').reverse().join('/');

    const startDate =
      dateRange.startDate === '' ? DateRangesss.startDate : formattedStartDate;
    const endDate =
      dateRange.endDate === '' ? DateRangesss.endDate : formattedEndDate;

    LdcApi({
      method: 'GET',
      url: `TreatmentNotes/GetPatientsComplicationTracker?startDate=${startDate}&endDate=${endDate}`,
    })
      .then((res) => {
        console.log('API Response:', res);
        if (Array.isArray(res?.data?.data)) {
          setFollowUpTrackerData(res.data.data);
        } else {
          setFollowUpTrackerData([]);
        }
        setLabLoader(false);
      })
      .catch((err) => {
        console.error('API Error:', err);
        setLabLoader(false);
      });
  };

  useEffect(() => {
    fetchFollowUpData();
  }, [finalDateRange, DateRangesss, statusSelect]);

  const [columnDefs] = useState([
    {
      headerName: 'Patient Name ',
      field: 'name',
      width: 180,
      minWidth: 150,
      filter: true,
      floatingFilter: true,
      filter: true,
      cellRenderer: function (params) {
        return (
          <p
            className=' cursors head_td '
            style={{
              width: '100%',
              height: '100%',
              margin: '0px',
              textDecoration: 'underline',
            }}
            onClick={() =>
              window.open(`/profile/${params.data.patientID}`, '_blank')
            }
            // onClick={() => copyToClipboard(`Patient name`, params.value)}
          >
            {params.value} :: {params.data.patientID}
          </p>
        );
      },
    },

    {
      headerName: 'Contact',
      field: 'mobile',
      width: 240,
      minWidth: 240,
      cellRenderer: function (params) {
        return (
          <p
            className=' cursors  '
            style={{ width: '100%', height: '100%', margin: '0px' }}
          >
            {params.data.mobile} / {params.data.email}
          </p>
        );
      },
    },
    {
      headerName: 'Created On',
      field: 'createdOn',
      width: 180,
      minWidth: 150,
      cellRenderer: function (params) {
        const formattedDate = params.value
          ? dayjs(params.value).format('DD/MM/YYYY hh:mm A')
          : '';

        return (
          <p
            className='ag_grid_caps cursors head_td'
            style={{ width: '100%', height: '100%', margin: '0px' }}
          >
            {formattedDate}
          </p>
        );
      },
    },

    {
      headerName: 'Created By',
      field: 'createdBy',
      width: 180,
      minWidth: 150,
      cellRenderer: function (params) {
        return (
          <p
            className='ag_grid_caps cursors head_td '
            style={{ width: '100%', height: '100%', margin: '0px' }}
          >
            {params.data.createdBy}
          </p>
        );
      },
    },
  ]);

  const defaultColDef = {
    flex: 1,
    resizable: true,
    height: 100,
    minWidth: 99,
    autoHeight: true,
    wrapText: true,
    enableColResize: true,
    autoSizeColumns: true,
  };

  return (
    <>
      <div>
        {/* <div className="d-flex justify-content-center mt-2 mb-2">
        <AptHeader startDate={startDate} onCalendar={onCalendar} onChangeDate={onChangeDate} />
      </div> */}
        <div className='shadow p-3 mb-4 bg-body rounded bg-primary text-white d-flex justify-content-center'>
          Complications Tracker
        </div>
        <Modal size='md' show={labLoader} centered className='labloader_modal'>
          <Modal.Body>
            <div className='spinner-container'>
              <div className={`loading-spinner`}></div>
            </div>
          </Modal.Body>
        </Modal>
        {/* <div
          style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}
        >
          <CustomButtons
            style={{
              padding: '5px',
              width: 'max-content',
              backgroundColor: isClickCompleted ? `#007bff` : `#fff`,
              color: isClickCompleted ? `#fff` : `#007bff`,
              boxShadow: 'none',
            }}
            variant='primary'
            name={`Completed`}
            onClick={filterCompleted}
          />
        </div> */}

        <div
          className='ag-theme-alpine mt-2'
          style={{ height: '78vh', width: '100%' }}
        >
          <div className='d-flex align-items-center my-4'>
            <div className='d-flex align-items-center mr-4'>
              <b className='mr-2' style={{ color: 'gray' }}>
                Date Range:
              </b>
              <RangePicker
                format={dateFormat}
                onChange={onChange}
                defaultValue={selectedRange}
              />
            </div>
          </div>

          {loader ? (
            <Skelton />
          ) : (
            <AgGridReact
              // ref={gridRef}
              rowData={followUpTrackerData}
              columnDefs={columnDefs}
              animateRows={true}
              defaultColDef={defaultColDef}
              // onGridReady={onGridReady}
              pagination={true}
              paginationPageSize={50}
              debounceVerticalScrollbar={true}
              getRowStyle={(params) => {
                if (params.data?.dueDays < 0) {
                  return { backgroundColor: '#fdd2d2' }; // light green background
                }
                return null; // default style
              }}
              paginationAutoPageSize={true}
            />
          )}
          {/* <DeleteProvisionDialog
            deleteAppointMentData={deleteAppointMentData}
            open={showProvisison.open}
            closeDialog={closeDialog}
            aptDataId={showProvisison.aptData}
          /> */}
        </div>
      </div>
    </>
  );
}

export default ComplicationTracker;
